/* eslint-disable */
import React, { FC, useEffect } from "react";
import { createUseStyles } from "react-jss";
import loadable from "@loadable/component";

import AudioPause from "Assets/images/audio_pause.svg";
import AudioPlay from "Assets/images/audio_play.svg";
import styles from "./styles";

interface Props {
  url: String;
  icon: any;
  pauseIcon?: any;
  audio: any;
  isPlaying: boolean;
  setAudio: (val: any) => {};
  setProgress: (val: any) => {};
  playAudio: any;
  pauseAudio: any;
  progress: any;
}

const Circle = loadable(async () => {
  const { Circle } = await import("rc-progress");
  return (props) => <Circle {...props} />;
});

const AudioPlayer: FC<Props> = (props: Props) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles({ ...props });

  const {
    url,
    icon = AudioPlay,
    audio,
    setAudio,
    playAudio,
    pauseAudio,
    pauseIcon,
    isPlaying = false,
    progress,
    setProgress,
  } = props;

  async function setAudioURL() {
    const { Howl } = await import("howler");
    setAudio(new Howl({ src: [url], html5: true }));
  }

  useEffect(() => {
    setAudioURL();
  }, [url]);

  useEffect(() => {
    if (audio) {
      const checkProgress = () => {
        if (audio.state() == "unloaded") {
          clearInterval(timer);
        } else {
          const progress = Math.ceil((audio.seek() / audio.duration()) * 100);

          if (audio.playing()) {
            setProgress(progress);
          }
          if (progress === 0) {
            audio.seek(0);
            setAudioURL();
          }
        }
      };
      const timer = setInterval(checkProgress, 500);

      return () => {
        clearInterval(timer);
      };
    }
    return undefined;
  }, [isPlaying, progress]);

  const play = (e: any) => {
    e.stopPropagation();
    audio.play();
    playAudio();
  };
  const pause = (e: any) => {
    e.stopPropagation();
    audio && audio.pause();
    pauseAudio();
  };

  return (
    <button
      type="button"
      id="bottomNavAudioPlayer"
      aria-label="Tour Stop Audio Transcript"
      className={`${classes.container} ${classes.button}`}
      onClick={!isPlaying ? play : pause}
      data-testid="audioPlayer"
    >
      <Circle
        percent={progress}
        strokeWidth={7}
        strokeColor="#085FE5"
        trailWidth={4}
        trailColor="#6799e6"
      />
      {!isPlaying ? (
        React.createElement(icon, {
          className: classes.audioControl,
          "data-testid": "play",
        })
      ) : pauseIcon ? (
        React.createElement(pauseIcon, {
          className: classes.audioControlLarge,
          "data-testid": "pause",
        })
      ) : (
        <AudioPause className={classes.audioControl} data-testid="pause" />
      )}
    </button>
  );
};

AudioPlayer.defaultProps = {
  pauseIcon: null,
};

export default AudioPlayer;
